<template>
	<div>
		<vx-card style="width: 500px" :title="$t('MapModule.Georeferencer')">
			<template slot="actions">
				<feather-icon
					icon="MinusIcon"
					@click.stop="minimizeGeoActive"
					class="cursor-pointer mr-3"
				></feather-icon>
				<feather-icon
					icon="CopyIcon"
					@click.stop="maximizeGeoActive"
					class="cursor-pointer mr-3"
				></feather-icon>
				<feather-icon icon="XIcon" @click.stop="closeGeoActive" class="cursor-pointer"></feather-icon>
			</template>
			<p class="opacity-85 text-sm">{{ $t("MapModule.GeoSub") }}</p>
			<component :is="scrollbarTag" class="scroll-area" :settings="settings" :key="$vs.rtl">
				<vx-card no-shadow>
					<form-geo
						ref="FormGeo"
						@minimizeGeoActiveEmit="minimizeGeoActive"
						@maximizeGeoActiveEmit="maximizeGeoActive"
						@showGeoAgain="showGeoAgain"
					></form-geo>
					<div class="flex items-center justify-center checkout-footer mt-base">
						<span class="cursor-pointer mr-2" @click="copyResults" v-if="isGeo">
							<feather-icon icon="CopyIcon" svgClasses="h-4 w-4" />
							<span class="ml-2">{{ $t("MapModule.CopyCoords") }}</span>
						</span>
						<span class="cursor-pointer ml-2" @click="geoAgain" v-if="isGeo">
							<feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
							<span class="ml-2">{{ $t("MapModule.GeoAgain") }}</span>
						</span>
					</div>
				</vx-card>
			</component>
		</vx-card>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import FormGeo from "@/components/zonification/FormGeo.vue";
import {clearMap} from "../../utils/HereMap";

export default {
	components: {
		VuePerfectScrollbar,
		FormGeo,
	},
	data() {
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			isGeo: false,
		};
	},
	computed: {
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		isGeoActive() {
			return this.$store.state.moduleMap.toggleGeorreferencer;
		},
	},
	methods: {
		copyResults() {
			this.$refs.FormGeo.copyResults();
		},
		geoAgain() {
			this.$refs.FormGeo.geoCoder();
		},
		closeGeoActive() {
			this.$store.commit("moduleMap/TOGGLE_GEO", false);
			clearMap();
		},
		minimizeGeoActive() {
			const headerMinimize = document.querySelectorAll(".vx-card .vx-card__header");
			const bodyMinimize = document.querySelectorAll(".vx-card .vx-card__collapsible-content");
			if (headerMinimize != null && bodyMinimize != null) {
				for (let i = 0; i < headerMinimize.length; i++) {
					headerMinimize[i].setAttribute("style", "height: 50px;");
				}
				for (let j = 0; j < bodyMinimize.length; j++) {
					bodyMinimize[j].setAttribute("style", "display: none;");
				}
			}
		},
		maximizeGeoActive() {
			const headerMinimize = document.querySelectorAll(".vx-card .vx-card__header");
			const bodyMinimize = document.querySelectorAll(".vx-card .vx-card__collapsible-content");
			if (headerMinimize != null && bodyMinimize != null) {
				for (let i = 0; i < headerMinimize.length; i++) {
					headerMinimize[i].removeAttribute("style");
				}
				for (let j = 0; j < bodyMinimize.length; j++) {
					bodyMinimize[j].removeAttribute("style");
				}
			}
		},
		showGeoAgain(val) {
			this.isGeo = val;
		},
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: auto;
	height: auto;
}

.minimize-header {
	height: 30px;
}
</style>
